import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import TableContainer from "Common/TableContainer";
import { Loader } from "../../../Common/Loader";
// Icons
import { Pencil, Search, Trash2, Plus, Link2, Link2Icon, Boxes, PackageCheck } from "lucide-react";
import Modal from 'Common/Components/Modal';
import AddCustomer from '../Customers/AddCustomer';

import { getBusiness, getUnverifiedBusiness, } from "../../../helpers/backend_helper";
import { ToastContainer } from "react-toastify";
import { PendingBusinessType } from "types/PendingBusinessType";
import filterDataBySearch from "Common/filterDataBySearch";

function BusinessList() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [businessList, setBusinessList] = useState<PendingBusinessType[]>([]);
  const [allBusinessList, setAllBusinessList] = useState<PendingBusinessType[]>([]);
  const [activeTab, setActiveTab] = useState("1");
  const [show, setShow] = useState<boolean>(false);
  const [customerData, setCustomerData] = useState<any>();

  const navigate = useNavigate();

  useEffect(() => {
    loadBusinesses('All');
  }, []);

  async function loadBusinesses(type: string) {
    try {
      
        let response = await getBusiness(type);
        if (response.success) {
          console.log("Businesses", response.data);
          const data = response.data as PendingBusinessType[];
          let sortedData =    data?.sort((a: PendingBusinessType, b: PendingBusinessType) => (a?.id > b?.id ? -1 : 1));
          setBusinessList(sortedData);
          setAllBusinessList(sortedData);


        //   setTimeout(() => {
        //     //toggleTab("5", "Not Submitted");
        //     let filteredBusiness = sortedData.filter((business: PendingBusinessType) => (business.status === 'Unverified'));
        //     setBusinessList(filteredBusiness);
        // }, 1000);

        }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  // useEffect(() => {
  //   if(allBusinessList.length > 0){
  //   toggleTab("5", "Not Submitted");
  //   }
  // }, [allBusinessList]);


 

  const handleEditDataClick = (ele: any) => {
    console.log(ele);
    navigate('/business-detail/' + ele.id);
  };

  const handleAddCustomer = () => {
    setCustomerData({});
    toggle();
  };

  const onSave = (result: any) => {
    loadBusinesses('All');
    toggle();
  };

  const toggle = useCallback(() => {
    setShow(!show);
    if (show) {
      setCustomerData(null);
    }
  }, [show]);

  const Status = ({ item }: any) => {
    switch (item) {
      case true:
        return (
          <span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent">
            Active
          </span>
        );
      case false:
        return (
          <span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-orange-100 border-transparent text-orange-500 dark:bg-orange-500/20 dark:border-transparent">
            InActive
          </span>
        );
    }
  };
  const columns = useMemo(
    () => [
       {
        header: "Business Name",
        accessorKey: "businessName",
        enableColumnFilter: true,
        enableSorting: false,
      },{
        header: "Owner Name",
        accessorKey: "ownerName",
        enableColumnFilter: true,
        enableSorting: false,
      },
     
      {
        header: "Phone Number",
        accessorKey: "phone",
        enableColumnFilter: true,
        enableSorting: false,
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: true,
        enableSorting: false,
      },
      ,
      {
        header: "City",
        accessorKey: "city",
        enableColumnFilter: true,
        enableSorting: false,
      },
      {
        header: "State",
        accessorKey: "state",
        enableColumnFilter: true,
        enableSorting: false,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: true,
        enableSorting: false,
      },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => (
          <div className="flex justify-start gap-2">
            <button
              className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
              onClick={() => {
                const data = cell.row.original;
                handleEditDataClick(data);
              }}>
              <Pencil className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
            </button>


          </div>
        ),
      },
    ],
    []
  );
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ['ownerName', 'businessName', 'status', 'city', 'state', 'phone', 'email'];
    filterDataBySearch(businessList, search, keysToSearch, setBusinessList);
  };


  const toggleTab = (tab: any, type: any) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredBusiness = allBusinessList;

      // filter by status
      if (type !== "all") {

        switch (tab) {
          case "2":
            filteredBusiness = allBusinessList.filter((business: PendingBusinessType) => (business.status === 'Verified'));
           // loadBusinesses('Verified');
            break;
          case "3":
            filteredBusiness = allBusinessList.filter((business: PendingBusinessType) => (business.status === 'Unverified'));
            //loadBusinesses('Unverified');
            break;
          case "4":
            filteredBusiness = allBusinessList.filter((business: PendingBusinessType) => (business.status === 'Rejected'));
            //loadBusinesses('Rejected');
            break;
            case "5":
              filteredBusiness = allBusinessList.filter((business: PendingBusinessType) => (business.status === 'Not Submitted'));
              console.log(filteredBusiness.length,allBusinessList.length)
              //loadBusinesses('Rejected');
              break;

          default:
            break;
        }
        //filteredBusiness = allBusinessList.filter((business: PendingBusinessType) => business.status === type);
      }
     setBusinessList(filteredBusiness);
    }
  };

  return (
    <React.Fragment>

      <ToastContainer closeButton={false} limit={1} />
      {/* <div className="card" id="userListTable">
        <div className="card-body"> */}
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
        <div className="xl:col-span-12">
          <div className="card" id="userListTable">
            <div className="card-body">
              <div className="flex items-center justify-between border-y border-dashed" style={{ padding: 10 }}>
                <div className="flex items-center space-x-4">
                  <h6 className="text-15">Businesses</h6>
                  <div className="flex flex-wrap gap-2">
                    <div className={`border rounded-lg p-2 transition-all duration-200 cursor-pointer ${activeTab === "1" ? "border-custom-500 bg-custom-50 dark:bg-custom-900/20" : "border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`} onClick={() => toggleTab("1", "all")}>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="statusFilter"
                          checked={activeTab === "1"}
                          onChange={() => toggleTab("1", "all")}
                          className="w-3 h-3 text-custom-500 bg-gray-100 border-gray-300 focus:ring-custom-500 dark:focus:ring-custom-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 rounded-full"
                        />
                        <span className={`text-xs font-medium ${activeTab === "1" ? "text-custom-500" : "text-gray-600 dark:text-gray-400"}`}>
                          <Boxes className="inline-block size-3 ltr:mr-1 rtl:ml-1" />
                          All
                        </span>
                      </label>
                    </div>

                    <div className={`border rounded-lg p-2 transition-all duration-200 cursor-pointer ${activeTab === "2" ? "border-custom-500 bg-custom-50 dark:bg-custom-900/20" : "border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`} onClick={() => toggleTab("2", "Verified")}>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="statusFilter"
                          checked={activeTab === "2"}
                          onChange={() => toggleTab("2", "Verified")}
                          className="w-3 h-3 text-custom-500 bg-gray-100 border-gray-300 focus:ring-custom-500 dark:focus:ring-custom-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 rounded-full"
                        />
                        <span className={`text-xs font-medium ${activeTab === "2" ? "text-custom-500" : "text-gray-600 dark:text-gray-400"}`}>
                          <Boxes className="inline-block size-3 ltr:mr-1 rtl:ml-1" />
                          Verified
                        </span>
                      </label>
                    </div>

                    <div className={`border rounded-lg p-2 transition-all duration-200 cursor-pointer ${activeTab === "3" ? "border-custom-500 bg-custom-50 dark:bg-custom-900/20" : "border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`} onClick={() => toggleTab("3", "Unverified")}>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="statusFilter"
                          checked={activeTab === "3"}
                          onChange={() => toggleTab("3", "Unverified")}
                          className="w-3 h-3 text-custom-500 bg-gray-100 border-gray-300 focus:ring-custom-500 dark:focus:ring-custom-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 rounded-full"
                        />
                        <span className={`text-xs font-medium ${activeTab === "3" ? "text-custom-500" : "text-gray-600 dark:text-gray-400"}`}>
                          <Boxes className="inline-block size-3 ltr:mr-1 rtl:ml-1" />
                          Unverified
                        </span>
                      </label>
                    </div>

                    <div className={`border rounded-lg p-2 transition-all duration-200 cursor-pointer ${activeTab === "4" ? "border-custom-500 bg-custom-50 dark:bg-custom-900/20" : "border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`} onClick={() => toggleTab("4", "Rejected")}>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="statusFilter"
                          checked={activeTab === "4"}
                          onChange={() => toggleTab("4", "Rejected")}
                          className="w-3 h-3 text-custom-500 bg-gray-100 border-gray-300 focus:ring-custom-500 dark:focus:ring-custom-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 rounded-full"
                        />
                        <span className={`text-xs font-medium ${activeTab === "4" ? "text-custom-500" : "text-gray-600 dark:text-gray-400"}`}>
                          <PackageCheck className="inline-block size-3 ltr:mr-1 rtl:ml-1" />
                          Rejected
                        </span>
                      </label>
                    </div>

                    <div className={`border rounded-lg p-2 transition-all duration-200 cursor-pointer ${activeTab === "5" ? "border-custom-500 bg-custom-50 dark:bg-custom-900/20" : "border-gray-200 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"}`} onClick={() => toggleTab("5", "Not Submitted")}>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="statusFilter"
                          checked={activeTab === "5"}
                          onChange={() => toggleTab("5", "Not Submitted")}
                          className="w-3 h-3 text-custom-500 bg-gray-100 border-gray-300 focus:ring-custom-500 dark:focus:ring-custom-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 rounded-full"
                        />
                        <span className={`text-xs font-medium ${activeTab === "5" ? "text-custom-500" : "text-gray-600 dark:text-gray-400"}`}>
                          <PackageCheck className="inline-block size-3 ltr:mr-1 rtl:ml-1" />
                          Not Submitted
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="shrink-0">
                  <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={handleAddCustomer}><Plus className="inline-block size-4" /> <span className="align-middle">Add Customer</span></button>
                </div>
              </div>
            </div>
           
            {isLoading ? (
              <Loader />
            ) : (
              <div style={{ marginBottom: 20 }} >
                {businessList && businessList?.length > 0 ? (
                  <TableContainer
                    isPagination={true}
                    columns={columns || []}
                    data={businessList || []}
                    customPageSize={10}
                    divclassName="overflow-x-auto"
                    tableclassName="w-full whitespace-nowrap"
                    theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
                    thclassName="px-2.5 py-0.5 font-semibold border-b border-slate-200 dark:border-zink-500"
                    tdclassName="px-2.5 py-0.5 border-y border-slate-200 dark:border-zink-500"
                    PaginationClassName="flex flex-col items-center gap-4 px-4 mt-3 md:flex-row"
                    SearchPlaceholder='Search...'
                    isGlobalFilter={false}
                    isSelect={true}
                  />
                ) : (
                  <div className="noresult">
                    <div className="py-6 text-center">
                      <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                      <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Customer Modal  */}
      <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[70rem] bg-white shadow rounded-md dark:bg-zink-600">
        {customerData ? <AddCustomer onSave={onSave} onHide={toggle} data={customerData} /> : <></>}
      </Modal>
    </React.Fragment>
  );
}

export default BusinessList;
